import React from 'react';
import '../styles/TalkExpertSection.css';

const TalkExpertSection = () => (
  <div className="talk-expert-section">
    {/* <h2>Need Guidance?</h2>
    <p>Talk to an expert for Personalised advice on Dubai real estate investment.</p> */}
    <a href="/contact" className="talk-expert-btn">
      <span className="talk-expert-icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 7C5 6.17157 5.67157 5.5 6.5 5.5H11.5C12.3284 5.5 13 6.17157 13 7V10C13 10.8284 12.3284 11.5 11.5 11.5H7.70711L5.85355 13.3536C5.53857 13.6686 5 13.4467 5 13.0251V11.5C5 11.5 5 10.8284 5 10V7Z" stroke="currentColor" strokeWidth="1.3"/>
        </svg>
      </span>
      Talk to an Expert
    </a>
  </div>
);

export default TalkExpertSection; 